module.exports = new __parcel__URL__("auditLog.9720e9be.svg").toString();